<script setup lang="ts">
import { type PropType, computed, toRef } from 'vue'
import type { SpeckleVersion } from '@haskoning/js-speckle'

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array as PropType<SpeckleVersion[]>,
    default: () => []
  },
  modelValue: { type: [String, null] as PropType<String | null>, required: true },
  getSpeckleData: {
    type: Function as PropType<(payload: { url: string; token: string }) => Promise<any>>,
    required: false
  },
  setSpeckleData: {
    type: Function as PropType<(data: any) => void>,
    required: false
  }
})

const emit = defineEmits<{
  update: []
  'update:modelValue': [Record<string, any>]
}>()

const modelValue = toRef(props, 'modelValue')

const selectedVersion = computed({
  get: () => {
    return props.items.length ? modelValue.value : null
  },
  set: (value: SpeckleVersion) => {
    emit('update:modelValue', value)
    emit('update')
  }
})
</script>

<template>
  <v-select
    label="Select GI Data Version"
    :items="items"
    v-model="selectedVersion"
    item-title="message"
    item-value="id"
    variant="filled"
    hide-details
    :loading="loading"
    v-bind="$attrs"
    clearable
  >
    <template v-slot:prepend-item>
      <slot name="prepend-item"></slot>
    </template>
    <template v-slot:selection="{ item }">
      <span class="header-text">{{ item?.raw.message || 'No version message available' }}</span>
    </template>
    <template v-slot:item="{ item, props }">
      <v-list-item v-bind="props" class="header-text-container">
        <template #title>
          <span class="header-text">{{ new Date(item.raw.createdAt).toLocaleString() }}</span>
        </template>
        <template #subtitle>
          <span class="subheader-text">{{ item.raw.message || 'No message' }}</span>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>
